import Button from "@common/controls/Button/component";
import ButtonsContainer from "@common/controls/Container/Buttons";
import Icon from "@common/controls/Icon/component";
import { IconType, SystemColor } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Modal from "../../component";
import "./style.less";

export interface ConfirmSuccessErrorModalContentProps {
  description?: string;
  isSuccess: boolean;
  text: string;
  icon?: IconType;
}

export type ConfirmSuccessErrorModalProps = ConfirmSuccessErrorModalContentProps & {
  isVisible: boolean;
  title?: string;
  onClose: () => any;
};

export const ConfirmSuccessErrorContent = (props: ConfirmSuccessErrorModalContentProps) => (
  <div className="confirm_container">
    <div className="message">
      {props.isSuccess ? (
        props.icon ? (
          <Icon className="icon" icon={props.icon} color={SystemColor.Green} />
        ) : (
          <Icon className="icon" icon={IconType.CircleCheckSolid} color={SystemColor.Green} />
        )
      ) : (
        <Icon className="icon" icon={IconType.Disabled} color={SystemColor.Red} />
      )}
      <div className="success_error_text">{props.text}</div>
      {props.description && <div className="success_error_description">{props.description}</div>}
    </div>
  </div>
);

const ConfirmSuccessErrorModal = (props: ConfirmSuccessErrorModalProps) => {
  const i18n = useI18n();

  return (
    <Modal {...props} className="success_error_modal" hasBackdrop isCentered width={450}>
      <Modal.Header title={props.title} />
      <Modal.Body>
        <ConfirmSuccessErrorContent {...props} />

        <ButtonsContainer align="center">
          <Button type="white" onClick={props.onClose}>
            {i18n.continue}
          </Button>
        </ButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmSuccessErrorModal;
